package data.repository

import domain.model.PullRequest
import domain.repository.GitHubRepository
import data.datasource.GitHubRemoteDataSource
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlin.coroutines.resume

class GitHubRepositoryImpl(
    private val remoteDataSource: GitHubRemoteDataSource,
    private val authRepository: domain.repository.AuthenticationRepository
) : GitHubRepository {
    
    override fun login() {
        authRepository.initiateLogin()
    }
    
    override fun logout() {
        remoteDataSource.logout()
    }
    
    // Callback-based methods for JavaScript compatibility
    override fun checkAuthentication(callback: (Boolean) -> Unit) {
        remoteDataSource.checkAuthentication(callback)
    }
    
    override fun fetchPullRequests(callback: (List<PullRequest>) -> Unit) {
        remoteDataSource.fetchPullRequests(callback)
    }
    
    // Suspend functions using suspendCancellableCoroutine to bridge callbacks
    override suspend fun isAuthenticated(): Boolean = suspendCancellableCoroutine { continuation ->
        remoteDataSource.checkAuthentication { isAuth ->
            continuation.resume(isAuth)
        }
    }
    
    override suspend fun getPullRequests(): List<PullRequest> = suspendCancellableCoroutine { continuation ->
        remoteDataSource.fetchPullRequests { pullRequests ->
            continuation.resume(pullRequests)
        }
    }
}
